import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'
import ValueBandsToolTip from '@Components/MatchComponents/ValueBandsToolTip'

interface RecordingGroupGridHeaderProps {
    isPendingStatus: boolean
    isRejectedStatus: boolean
}

const RecordingGroupGridHeader = ({ isPendingStatus, isRejectedStatus }: RecordingGroupGridHeaderProps) => (
    <>
        <div className="cell-padding-left" role="columnheader">
            ISRC
        </div>
        <div role="columnheader">Recording Title</div>
        <div role="columnheader">Recording Artist</div>
        <div role="columnheader">
            DSP Supplied Writers
            <CustomToolTip
                type="?"
                inverse
                info="Writers listed in this column are the result of information provided by the DSP"
            />
        </div>
        {isPendingStatus && (
            <div role="columnheader" className="cell-padding-left">
                Estimated Value
                <ValueBandsToolTip inverseColor />
            </div>
        )}
        {isRejectedStatus && <div role="columnheader">Rejection Reason</div>}
        <div className="cell-padding-right" role="columnheader">
            &nbsp;
        </div>
    </>
)

export default RecordingGroupGridHeader
